var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterView',{staticClass:"Campaigns--child Loading__target p-0"})
}
var staticRenderFns = []

export { render, staticRenderFns }